import { ApiError } from '../api/client';

/**
 * Mensagem de erro amigavel compartilhada (M8-WEB#37). Antes, so o AdminPanel tratava o 403; o
 * resto da UI (FileExplorer, ChatPage, store) jogava `String(e)` cru — inconsistente e cru.
 * Este util centraliza o mapeamento dos codigos/erros comuns para texto humano.
 */
export function friendlyError(err: unknown): string {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'forbidden':
      case 'forbidden_csrf':
        return 'sem permissao para esta acao (escopo insuficiente ou sessao expirada)';
      case 'forbidden_origin':
        return 'origem nao permitida (acesso bloqueado por seguranca)';
      case 'unauthorized':
        return 'nao autenticado — faca login novamente';
      case 'forbidden_path':
      case 'forbidden_or_not_found':
        return 'caminho fora das pastas permitidas ou inexistente';
      case 'not_configured':
        return 'recurso nao configurado no servidor';
      default:
        if (err.status === 429) return 'muitas tentativas — aguarde um momento';
        if (err.status >= 500) return 'erro no servidor — tente novamente';
        return err.message || `erro (${err.status})`;
    }
  }
  const s = err instanceof Error ? err.message : String(err);
  if (/Failed to fetch|NetworkError|network/i.test(s)) {
    return 'falha de conexao — verifique a rede';
  }
  return s;
}
